import styled from 'styled-components';

export const H4 = styled.h4`
  margin: 0 0 8px 0;
  padding: 0 15px;
  font-size: 14px;
  ${(p) => p.theme.ProximaNova};
  color: ${(p) => p.theme.darkGray};
`;
